import flow from './flow.svg';
import mobile_app from './mobile_app.svg';
import web from './web.svg';
import backend from './backend.svg';

export { flow, mobile_app, backend, web };
export default { flow, mobile_app, backend, web };
